<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import type { CurrentRoute } from "svelte-router-spa/types/components/route";

  import SubNavUnit from "@/components/subnav-unit.svelte";
  import Spacer from "@/components/spacer.svelte";
  import router from "@/router";

  let pathname;
  $: {
    pathname = currentRoute.path.split("/").pop();
  }
  const menulist1 = [
    { name: "pf_garden", label: "시설원예" },
    { name: "pf_barn", label: "축사" },
    { name: "pf_field", label: "노지/관수" },
    { name: "pf_model", label: "모형제작" },
    { name: "pf_misc", label: "기타" },
  ];
  const menulist2 = [
    { name: "news", label: "소식" },
    { name: "video", label: "영상" },
    { name: "press", label: "언론보도" },
  ];
  const menulist3 = [
    { name: "announce", label: "공지사항" },
    { name: "faq", label: "주로하는 질문" },
    { name: "qna", label: "사용관련" },
    { name: "govbiz", label: "정부지원사업" },
  ];
  const menulist = router.find((x) => x.id == "bandiburri")?.nestedRoutes || [];
  const m1 = ["news", "video", "press"];

  export let currentRoute: CurrentRoute;
</script>

<div id="wrap">
  <h1>
    {#if pathname.indexOf("pf") != -1}PORTFOLIO
    {:else if m1.includes(pathname)}
      MEDIA
    {:else}CUSTOMER CENTER{/if}
  </h1>
  <Spacer size="2rem" />

  <div class="position-relative">
    {#if pathname.indexOf("pf") != -1}
      <div class="position-absolute w750-mobile start-50 translate-middle-x">
        <Row style="--bs-gutter-x: 0 !important;">
          {#each menulist1 as menu, i}
            <Col style="padding: 0 !important;">
              <SubNavUnit
                href="/board/list/{menu.name}"
                active={pathname == menu.name}
              >
                {menu.label}
              </SubNavUnit>
            </Col>
          {/each}
        </Row>
      </div>
    {:else if m1.includes(pathname)}
      <div class="position-absolute w450-mobile start-50 translate-middle-x">
        <Row style="--bs-gutter-x: 0 !important;">
          {#each menulist2 as menu, i}
            <Col style="padding: 0 !important;">
              <SubNavUnit
                href="/board/list/{menu.name}"
                active={pathname == menu.name}
              >
                {menu.label}
              </SubNavUnit>
            </Col>
          {/each}
        </Row>
      </div>
    {:else}
      <div class="position-absolute w600-mobile start-50 translate-middle-x">
        <Row style="--bs-gutter-x: 0 !important;">
          {#each menulist3 as menu, i}
            <Col style="padding: 0 !important;">
              <SubNavUnit
                href="/board/list/{menu.name}"
                active={pathname == menu.name}
              >
                {menu.label}
              </SubNavUnit>
            </Col>
          {/each}
        </Row>
      </div>{/if}
  </div>

  <Spacer size="5rem" class_ext="pc" />
  <Spacer size="10rem" class_ext="mobile" />
</div>

<style lang="scss">
  .w450-mobile {
    width: 330px;
  }
  .w600-mobile {
    width: 330px;
  }
  .w750-mobile {
    width: 330px;
  }
  @media (min-width: 768px) {
    .w450-mobile {
      width: 450px !important;
    }
    .w600-mobile {
      width: 600px !important;
    }
    .w750-mobile {
      width: 750px !important;
    }
  }

  #wrap {
    color: #5c3327;

    h1 {
      font-size: 3rem;
      font-weight: 700;
      text-align: center;
    }
  }
</style>
